import { render, staticRenderFns } from "./TonnageBasins.vue?vue&type=template&id=09d7d20e&scoped=true&"
import script from "./TonnageBasins.vue?vue&type=script&lang=js&"
export * from "./TonnageBasins.vue?vue&type=script&lang=js&"
import style0 from "./TonnageBasins.vue?vue&type=style&index=0&id=09d7d20e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7d20e",
  null
  
)

export default component.exports